// Configuration module for Web Presence server

// Default configuration values
const defaultConfig = {
  // Discord RPC configuration
  discord: {
    clientId: "1370122815273046117", // Application ID (not logged for privacy)
    reconnectAttempts: 0,
    maxReconnectAttempts: 10,
  },

  // Server configuration
  server: {
    port: 8874,
    activityTimeout: 180000, // 3 minutes timeout for client activity (4x the heartbeat interval)
    inactiveCheckInterval: 15000, // Check for inactive clients every 15 seconds
  },

  // Presence configuration
  presence: {
    enabled: true,
    defaultPrefix: "Viewing", // Default prefix for details text
    creditText: "by Utkarsh", // Credit text to show in state
    buttons: [
      {
        label: "GitHub Repository",
        url: "https://github.com/utkarshthedev/WebPresence",
      },
      {
        label: "Follow on Twitter",
        url: "https://twitter.com/utkarshthedev",
      },
    ],
    largeImageKey: "web",
    smallImageKey: "me",
    smallImageText: "Utkarsh Tiwari",
    // Browser-specific icons
    browserIcons: {
      chrome: {
        iconKey: "chrome",
        text: "Google Chrome",
      },
      firefox: {
        iconKey: "firefox",
        text: "Mozilla Firefox",
      },
      default: {
        iconKey: "me",
        text: "Utkarsh Tiwari",
      },
    },
  },
};

// Runtime configuration that can be modified
const runtimeConfig = {
  ...defaultConfig,

  // User preferences that can be customized
  userPreferences: {
    prefixText: defaultConfig.presence.defaultPrefix,
    disabledSites: [] as string[], // Sites where presence should be disabled
    alwaysEnabledSites: [] as string[], // Sites where presence should always be shown
    continuousTimer: true, // Keep timer running when switching tabs (enabled by default)
  },
};

// Export configuration
export const config = {
  // Get the current configuration
  get: () => runtimeConfig,

  // Get Discord configuration
  getDiscord: () => runtimeConfig.discord,

  // Get server configuration
  getServer: () => runtimeConfig.server,

  // Get presence configuration
  getPresence: () => runtimeConfig.presence,

  // Get user preferences
  getUserPreferences: () => runtimeConfig.userPreferences,

  // Update user preferences
  updateUserPreferences: (
    preferences: Partial<typeof runtimeConfig.userPreferences>
  ) => {
    runtimeConfig.userPreferences = {
      ...runtimeConfig.userPreferences,
      ...preferences,
    };
    return runtimeConfig.userPreferences;
  },

  // Reset user preferences to defaults
  resetUserPreferences: () => {
    runtimeConfig.userPreferences.prefixText =
      defaultConfig.presence.defaultPrefix;
    runtimeConfig.userPreferences.disabledSites = [];
    runtimeConfig.userPreferences.alwaysEnabledSites = [];
    runtimeConfig.userPreferences.continuousTimer = true;
    return runtimeConfig.userPreferences;
  },
};
